<div class="btn-bar">
  @if (!createMode && !dragMode) {
    <button class="btn btn-primary"
      (click)="startCreateMode()"
      translate="map.add">
    </button>
  }
  @if (!createMode && !dragMode) {
    <button class="btn btn-primary"
      (click)="startDragMode()" translate="map.drag">
    </button>
  }

  @if (createMode || dragMode) {
    <button class="btn btn-outline-secondary"
      (click)="resetMapAndStopEditMode()"
      translate="common.cancel">
    </button>
  }
  @if (dragMode) {
    <button class="btn btn-primary"
      (click)="emitSelectedItem()"
      [disabled]="!selectedItem"
      translate="common.save">
    </button>
  }
</div>

@if (dragMode) {
  <div class="col-12 text-center">
    <p translate="services.manage.coordinates.notifications.selectPlace"></p>
  </div>
}
@if (createMode) {
  <div class="col-12 text-center">
    <p translate="services.manage.coordinates.notifications.createPlace"></p>
  </div>
}

<div class="map-container overflow-hidden">
  <div class="btn-container">
    <div class="btn-group" role="group">
      <button id="zoom-in" type="button" class="btn btn-primary">+</button>
      <button id="zoom-out" type="button" class="btn btn-primary">-</button>
    </div>
  </div>
  <svg class="map" id="d3_map" width="1240" height="500"></svg>
</div>
